import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { Metafield } from 'src/app/shop';

@Component({
    selector: 'app-product-specifications',
    templateUrl: './product-specifications.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductSpecificationsComponent {
  private dict = new FromDictionaryPipe(this.lang);

  @Input() specs: Metafield[] = [];

  constructor(private lang: LanguageService) {}

  printValue(spec: Metafield) {
    if (spec.type === 'boolean') {
      return spec.value === 'true' ? this.dict.transform('ja') : this.dict.transform('nee');
    }
    return spec.value;
  }

  trackByFn(index: number, item: Metafield) {
    return item?.id;
  }
  trackByLinks(index: number, item: { title: string; handle: string }) {
    return item?.handle;
  }
}
